import React from 'react';
import './css/Petprofile.css';
import cookie from 'react-cookies';

class PetProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 0,
      grouth: 0,
      hungery: 0,
      clean: 0,
      health: 0,
      mood: 0,
      now: '成长中',
      hover: 0,
    };
  }

  getValue = () => {
    const grouth = parseInt(cookie.load('grouth'));
    const hungery = parseInt(cookie.load('hungery'));
    const clean = parseInt(cookie.load('clean'));
    const health = parseInt(cookie.load('health'));
    const mood = parseInt(cookie.load('mood'));
    const now = decodeURI(cookie.load('now'));
    this.setState({
      time: Math.floor(grouth / 500),
      grouth: grouth % 500,
      hungery: hungery,
      clean: clean,
      health: health,
      mood: mood,
      now: now,
    });
  };

  componentDidMount() {
    this.getValue();
  }

  hidden = () => {
    this.setState({ hover: 0 });
  };

  refresh = () => {
    this.getValue();
    this.setState({ hover: 1 });
    setTimeout(this.hidden, 150);
  };

  render() {
    return (
      <div
        className="profile"
        ref={this.props.refpath}
        onMouseMove={this.props.MouseOver}
        onMouseLeave={this.props.MouseLeave}
      >
        <div className="head"></div>
        <div className="head_fresh" onClick={this.refresh}></div>
        <div className="info">
          <div className="item">
            <div className="title">昵称:&nbsp;</div>
            <div className="value">Q宠宝贝</div>
          </div>
          <div className="item">
            <div className="title">号码:&nbsp;</div>
            <div className="value">751791623</div>
          </div>
          <div className="item">
            <div className="title">等级:&nbsp;</div>
            <div className="value">2&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <div className="bone"></div>
            <div className="bone"></div>
            <div className="bone"></div>
          </div>
          <div className="item">
            <div className="title">年龄:&nbsp;</div>
            <div className="value">{this.state.time}小时</div>
          </div>
          <div
            className="item"
            style={{ cursor: 'pointer' }}
            onMouseEnter={() => this.setState({ hover: 1 })}
            onMouseLeave={() => this.setState({ hover: 0 })}
          >
            <div className="title">成长:&nbsp;</div>
            <div className="basic_bar">&nbsp;</div>
            <div
              className="bar_value"
              style={{
                width: (this.state.grouth * 100) / 500 + 'px',
              }}
            >
              &nbsp;
            </div>
            <div
              className="grouth"
              style={{
                marginTop: `-16px`,
                marginLeft: `60px`,
                position: `absolute`,
                zIndex: 1,
                color: 'black',
                display: `${this.state.hover ? 'block' : 'none'}`,
              }}
            >
              {this.state.grouth}/500
            </div>
          </div>
          <div
            className="item"
            style={{ cursor: 'pointer' }}
            onMouseEnter={() => this.setState({ hover: 1 })}
            onMouseLeave={() => this.setState({ hover: 0 })}
          >
            <div className="title">饥饿:&nbsp;</div>
            <div className="basic_bar">&nbsp;</div>
            <div
              className="bar_value1"
              style={{
                width: (this.state.hungery * 100) / 800 + 'px',
              }}
            >
              &nbsp;
            </div>
            <div
              className="hungery"
              style={{
                marginTop: `-16px`,
                marginLeft: `60px`,
                position: `absolute`,
                zIndex: 1,
                color: 'black',
                display: `${this.state.hover ? 'block' : 'none'}`,
              }}
            >
              {this.state.hungery}/800
            </div>
          </div>
          <div
            className="item"
            style={{ cursor: 'pointer' }}
            onMouseEnter={() => this.setState({ hover: 1 })}
            onMouseLeave={() => this.setState({ hover: 0 })}
          >
            <div className="title">清洁:&nbsp;</div>
            <div className="basic_bar">&nbsp;</div>
            <div
              className="bar_value1"
              style={{
                width: (this.state.clean * 100) / 1000 + 'px',
              }}
            >
              &nbsp;
            </div>
            <div
              className="clean"
              style={{
                marginTop: `-16px`,
                marginLeft: `60px`,
                position: `absolute`,
                zIndex: 1,
                color: 'black',
                display: `${this.state.hover ? 'block' : 'none'}`,
              }}
            >
              {this.state.clean}/1000
            </div>
          </div>
          <div
            className="item"
            style={{ cursor: 'pointer' }}
            onMouseEnter={() => this.setState({ hover: 1 })}
            onMouseLeave={() => this.setState({ hover: 0 })}
          >
            <div className="title">健康:&nbsp;</div>
            <div className="basic_bar">&nbsp;</div>
            <div
              className="bar_value1"
              style={{
                width: (this.state.health * 100) / 1000 + 'px',
              }}
            >
              &nbsp;
            </div>
            <div
              className="health"
              style={{
                marginTop: `-16px`,
                marginLeft: `60px`,
                position: `absolute`,
                zIndex: 1,
                color: 'black',
                display: `${this.state.hover ? 'block' : 'none'}`,
              }}
            >
              {this.state.health}/1000
            </div>
          </div>
          <div
            className="item"
            style={{ cursor: 'pointer' }}
            onMouseEnter={() => this.setState({ hover: 1 })}
            onMouseLeave={() => this.setState({ hover: 0 })}
          >
            <div className="title">心情:&nbsp;</div>
            <div className="basic_bar">&nbsp;</div>
            <div
              className="bar_value1"
              style={{
                width: (this.state.mood * 100) / 1000 + 'px',
              }}
            >
              &nbsp;
            </div>
            <div
              className="mood"
              style={{
                marginTop: `-16px`,
                marginLeft: `60px`,
                position: `absolute`,
                zIndex: 1,
                color: 'black',
                display: `${this.state.hover ? 'block' : 'none'}`,
              }}
            >
              {this.state.mood}/1000
            </div>
          </div>
          <div className="item">
            <div className="title">状态:&nbsp;</div>
            <div className="value">{this.state.now}</div>
          </div>
        </div>
        <div className="footer_left"></div>
        <div className="footer_right2"></div>
        <div className="footer_right1"></div>
      </div>
    );
  }
}

export default PetProfile;
